export default __webpack_public_path__ + "static/media/bg-beneficio-produto.d171ebd9.webp";